// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__3DIIG","ranges":"BmiRanges_ranges__3YAkW"};